// Single-key wrapper around localStorage for the latest FWA story_runs.uuid.
// All operations swallow errors so the host page never breaks if localStorage
// is unavailable (private mode, disabled by user, quota errors).

export const KEY = "bz.fwa.run-uuid"

export const read = () => {
  try {
    return localStorage.getItem(KEY)
  } catch (_e) {
    return null
  }
}

export const write = (uuid) => {
  if (!uuid) return
  try {
    localStorage.setItem(KEY, uuid)
  } catch (_e) {
    /* localStorage unavailable — silently skip */
  }
}

export const clear = () => {
  try {
    localStorage.removeItem(KEY)
  } catch (_e) {
    /* localStorage unavailable — silently skip */
  }
}
